import { render, staticRenderFns } from "./studentQuestionLisWrongTopic.vue?vue&type=template&id=2199dd74&scoped=true"
import script from "./studentQuestionLisWrongTopic.vue?vue&type=script&lang=js"
export * from "./studentQuestionLisWrongTopic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2199dd74",
  null
  
)

export default component.exports